export type NewsStatisticsDTO = {
  accountants: number;
  houses: number;
  managers: number;
  providers: number;
  tenants: number;
  workers_access: number;
  workers_email: number;
  contractors: number;
};

export const DEFAULT_NEWS_STATISTICS: NewsStatisticsDTO = {
  accountants: 0,
  houses: 0,
  managers: 0,
  providers: 0,
  tenants: 0,
  workers_access: 0,
  workers_email: 0,
  contractors: 0,
};

export type NewsDailyStatEntryDTO = {
  _id: string | null;
  managers: number | null;
  accountants: number | null;
  date: string | null;
  datetime: string | null;
  workers: number | null;
  tenants: number | null;
  count: number | null;
  contractors: number | null;
};
